/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import styled from 'styled-components';
import { getPickupPoints, setPickupPoint } from '../addCommandActions';
import { Title } from './style';

const CustomPaper = styled(Paper)`
  padding: 20px;
  margin: 15px 20px;
  cursor: pointer;
`;

const Container = styled.div`
  height: 55vh;
  overflow: scroll;
`;

const OpeningHour = styled.ul`
  margin: 0;
  padding: 0;
`;

OpeningHour.Container = styled.li`
  list-style: none;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
`;

const NoPickupPoint = styled.div`
  text-align: center;
  font-size: 1.4em;
  font-weight: 400;
`;

const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
`;

const SelectPickupPointStep = ({
  dispatchGetPickupPoints,
  pickupPoints,
  getPickupPointsParams,
  previousPage,
  dispatchSetPickupPoint,
  pickupPointLoading,
  nextPage
}) => {
  useEffect(() => {
    dispatchGetPickupPoints(getPickupPointsParams);
    // eslint-disable-next-line
  }, [dispatchGetPickupPoints]);
  const weekDay = [
    'Lundi',
    'Mardi',
    'Mercredi',
    'Jeudi',
    'Vendredi',
    'Samedi',
    'Dimanche'
  ];
  return (
    <div>
      <Title>Sélectionner un point relais</Title>
      {pickupPointLoading && (
        <LoaderContainer>
          <CircularProgress style={{ width: 150, height: 150 }} />
        </LoaderContainer>
      )}
      {!pickupPointLoading && pickupPoints.length ? (
        <Container>
          {pickupPoints.map(pickupPoint => (
            <CustomPaper
              key={pickupPoint.id}
              onClick={() => {
                dispatchSetPickupPoint(pickupPoint);
                nextPage();
              }}
            >
              <h3 style={{ textAlign: 'center' }}>{pickupPoint.name}</h3>
              <Grid container>
                <Grid item md={6}>
                  <span>Adresse :</span>
                  <Box mt={2} />
                  <div>{pickupPoint.street}</div>
                  <div>
                    {pickupPoint.postalCode}, {pickupPoint.city}
                  </div>
                  <div>Distance {pickupPoint.distance} m</div>
                </Grid>
                <Grid item md={6}>
                  <div>Horraires :</div>
                  <Box mt={2} />
                  <table>
                    <tbody>
                      {pickupPoint.openingHours.map((day, index) => (
                        <tr key={index} className="opening-hours">
                          <td>{`${weekDay[index]}`}</td>
                          {day.length ? (
                            day.map((hour, indexDay) => (
                              <td key={indexDay}>
                                {hour.start} - {hour.end}{' '}
                                {day.length > 1 && index !== day.length - 1}
                              </td>
                            ))
                          ) : (
                            <td>
                              <strong>Fermé</strong>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Grid>
              </Grid>
            </CustomPaper>
          ))}
        </Container>
      ) : null}
      {!pickupPointLoading && !pickupPoints.length ? (
        <NoPickupPoint>
          <p>
            Nous n’avons trouvé aucun point relais, veuillez modifier
            l&lsquo;adresse de destination ou choisir une offre de livraison de
            type résidentielle
          </p>
        </NoPickupPoint>
      ) : null}
      {!pickupPointLoading && (
        <ButtonContainer>
          <Button
            variant="contained"
            color="primary"
            onClick={previousPage}
            style={{ width: 130 }}
          >
            Précédent
          </Button>
        </ButtonContainer>
      )}
    </div>
  );
};

const mapStateToProps = state => {
  const selector = formValueSelector('addCommandForm');
  const postalCode = selector(state, 'recipientAddress.postalCode');
  const city = selector(state, 'recipientAddress.city');
  const street = selector(state, 'recipientAddress.street');
  return {
    pickupPoints: state.addCommand.pickupPoints,
    pickupPointLoading: state.addCommand.pickupPointLoading,
    getPickupPointsParams: {
      countryCode: 'FR',
      city,
      postalCode,
      street
    }
  };
};

const mapDispatchToProps = dispatch => ({
  dispatchGetPickupPoints: params => dispatch(getPickupPoints(params)),
  dispatchSetPickupPoint: pickupPoint => dispatch(setPickupPoint(pickupPoint))
});

SelectPickupPointStep.propTypes = {
  dispatchGetPickupPoints: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  dispatchSetPickupPoint: PropTypes.func.isRequired,
  getPickupPointsParams: PropTypes.object.isRequired,
  pickupPointLoading: PropTypes.bool.isRequired,
  pickupPoints: PropTypes.array
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectPickupPointStep);
